// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"9cd1a499798ba4a4cd9a","936":"cb541fb95a19f2d4cd47"}[chunkId] + ".js";
};